import $ from 'jquery';
import '../modules/mpro.push-queue';

// Module namespace
// const mpro = window.mpro || {};

// Static methods
/** @type {((arg0: JQuery<HTMLElement>) => void)[]} */
const fragmentCallbacks = [];
// Delegate methods
/** @type {(($: JQueryStatic) => void)[]} */
const delegateCallbacks = [];
let libIsReady = false;

// Watch for lib ready event
mpro.once('ready', () => {
	libIsReady = true;
});

/**
 * Extend the namespace object with new props/methods
 *
 * @param  {...any} modules
 */
mpro.extendSelf = (...modules) => {
	for (const module of modules) {
		for (const prop in module) {
			if (Object.hasOwn(module, prop)) {
				if (prop in mpro) {
					console.warn('Overriding namespace prop %o: $o with %o', prop, mpro[prop], module[prop]);
				}
				mpro[prop] = module[prop];
			}
		}
	}
	return mpro;
};

/**
 * Add init function that is executed on every page/fragment render
 *
 * @param {($container: JQuery) => void} fn
 */
mpro.addInitStatic = (fn) => {
	fragmentCallbacks.push(fn);

	if (libIsReady === true) {
		console.warn('A call to addInitStatic was made when lib is \'ready\'');
		fn(mpro.get$B());
	}
};

/**
 * Initialize all static callbacks
 *
 * @param {JQuery} $container
 */
mpro.initStatics = ($container) => {
	for (const cb of fragmentCallbacks) {
		// eslint-disable-next-line n/callback-return
		cb($container);
	}
};

/**
 * Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
 *
 * @param {($: jQuery) => void} fn
 */
mpro.addInitDelegate = (fn) => {
	// No need to queue this delegate
	if (libIsReady === true) {
		// Note: relies on the global $ object to be available
		fn($);
	}
	// Wait for lib to be ready
	else {
		delegateCallbacks.push(fn);
	}
};

/**
 * Initialize all delegate callbacks
 *
 * @param {jQuery} $
 */
mpro.initDelegates = ($) => {

	if (libIsReady) {
		console.warn('Cannot call initDelegates when lib is \'ready\'');
		return;
	}

	// Process the delegates callback queue and empty it
	while (delegateCallbacks.length > 0) {
		delegateCallbacks.shift()($);
	}
};

/**
 * Copy the temporary callbacks array to the mpro object
 *
 * @param {any} tempArray
 */
mpro.initNamespace = (tempArray) => {

	// Init the config object
	mpro.initConfig(tempArray);

	// Emit the init-config event
	mpro.emit('init-config');

	// Prepare page event handlers
	mpro.initPageEvents();

	let readyJS;

	// Initialized as an array
	if (Array.isArray(tempArray)) {

		readyJS = tempArray;

		const __copyProps = function(O, C) {
			for (const s in O) {
				if (Number.isNaN(Number(s)) && Object.hasOwn(O, s)) {
					C[s] = O[s];
				}
			}
		};
		__copyProps(tempArray, mpro);
	}

	// Load all SHM pending callbacks
	if (readyJS) {
		mpro.push(...readyJS);
		// readyJS = undefined;
	}

	// Load pending api callbacks
	mpro.loadPendingApiCalls();

	return mpro;
};

/**
 * Init the mpro namespace
 */
mpro.init = ({ now = false } = {}) => {

	// Emit the init event
	mpro.emit('init');

	// Bind all delegate handlers to the onReady event
	// Note: relies on the global $ object to be available

	// Just run the function when init() is called (required the defer tag on the main script)
	if (now === true) {
		mpro.emit('did-navigate-in', { type: 'load', $containers: mpro.get$B() });
		mpro.initDelegates($);
	}
	// Run when the DOM is ready
	else {
		mpro.emit('did-navigate-in', { type: 'load', $containers: mpro.get$B() });
		$(mpro.initDelegates);
	}
};

export default mpro;
